import '../../types/dataLayer.d.ts';
import CheckoutBasket from '../../checkout/CheckoutBasket';

export default class CartHandler {
    basketBlock = document.querySelector('.js-basket-block');
    cartBlock = document.querySelector('.basket-grid');
    configMutationObserver = {
        attributes: true,
        childList: true,
        subtree: true,
    };

    private static getBasketUrl = '?ajaxAction=getBasket';

    private static typeEventToWatchMiniCart = 'childList';

    private static isAuth: boolean;

    private static email: string;

    private static reloadOne: boolean = false;

    constructor(isAuth: boolean, email: string = '') {
        CartHandler.isAuth = isAuth;
        CartHandler.email = email;

        /**Будет реагировать на изменение js-cart на всех страницах где она есть**/
        const observer = new MutationObserver(this.callbackMiniCart);
        if (this.basketBlock !== null) {
            observer.observe(this.basketBlock, this.configMutationObserver);
        }
        if (this.cartBlock !== null) {
            CartHandler.reloadOne = true;
            if (CartHandler.reloadOne) {
                document
                    .querySelector(CheckoutBasket.basketContainer)
                    .addEventListener('reload-complete', (event) => {
                        CartHandler.fetchBasket();
                    });
            }
        }
    }

    callbackMiniCart(mutationsList: any, observer: any) {
        let callOnce = false;

        for (const mutation of mutationsList) {
            if (
                mutation.type === CartHandler.typeEventToWatchMiniCart &&
                !callOnce
            ) {
                CartHandler.fetchBasket();
                callOnce = true;
            }
        }
    }

    private static fetchBasket() {
        let data: Data = {
            event: 'updateCart',
            eventProps: {
                dataMindbox: {
                    data: {
                        productList: [],
                    },
                },
            },
            productList: [],
        };
        if (CartHandler.isAuth) {
            data.email = data.eventProps.dataMindbox.data.customer =
                CartHandler.email;
        }
        fetch(CartHandler.getBasketUrl)
            .then((response) => {
                return response.json();
            })
            .then((items) => {
                if (items.length > 0) {
                    data.eventProps.dataMindbox.operation = 'Website.SetCart';
                    let i = 0;

                    items.forEach((value) => {
                        const item = {
                            count: value.QUANTITY,
                            pricePerItem: value.PRICE,
                            product: {
                                ids: {
                                    website: value.VendorCode,
                                },
                            },
                        };

                        data.productList[i] = item;
                        data.eventProps.dataMindbox.data.productList[i] = item;
                        i += 1;
                    });
                } else {
                    window.mindbox("async", {
                        operation: "Website.ClearCart",
                        data: {}
                    });

                }
                data.url = window.location.href;
                global.window.dataLayer.push(data);
            });
        CartHandler.reloadOne = false;
    }
}
